import React, { useState, useEffect, useCallback } from "react";

const Calculator: React.FC = () => {
  const [input, setInput] = useState<string>("");

  const handleButtonClick = useCallback((value: string) => {
    if (value === "AC") {
      setInput(""); // Clear input
    } else if (value === "+/-") {
      setInput((prev) => (prev.startsWith("-") ? prev.slice(1) : `-${prev}`)); // Toggle sign
    } else if (value === "%") {
      setInput((prev) => (parseFloat(prev) / 100).toString()); // Percentage
    } else if (value === "=") {
      try {
        setInput(eval(input).toString()); // Evaluate the expression
      } catch {
        setInput("Error");
      }
    } else {
      setInput((prev) => prev + value); // Add digit or operator to the input
    }
  }, [input])

  const handleKeyPress = useCallback((event: KeyboardEvent) => {
    const { key } = event;
    if (!isNaN(Number(key)) || ["+", "-", "*", "/", ".", "=", "%"].includes(key)) {
      handleButtonClick(key === "=" ? "=" : key);
    } else if (key === "Enter") {
      handleButtonClick("=");
    } else if (key === "Backspace") {
      setInput((prev) => prev.slice(0, -1));
    } else if (key === "Escape") {
      handleButtonClick("AC");
    }
  }, [handleButtonClick])

  useEffect(() => {
    window.addEventListener("keydown", handleKeyPress);
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [handleKeyPress]);

  return (
    <div className="bg-zinc-200 dark:bg-zinc-900 p-6 shadow-lg w-screen h-[calc(100vh-6.5rem)] md:h-fit md:w-96">
      <div className="bg-zinc-300 dark:bg-zinc-800 h-96 md:h-28 text-3xl text-black dark:text-white p-4 rounded-lg mb-4 shadow-inner flex justify-end items-end">
        {input || "0"}
      </div>
      <div className="grid grid-cols-4 gap-3 select-none">
        {[
          "AC", "+/-", "%", "/",
          "7", "8", "9", "*",
          "4", "5", "6", "-",
          "1", "2", "3", "+",
          "0", ".", "="
        ].map((btn) => (
          <button
            key={btn}
            onClick={() => handleButtonClick(btn)}
            className={`${["/", "*", "-", "+", "="].includes(btn)
              ? "bg-green-600 hover:bg-green-500 text-white"
              : (["AC", "+/-", "%"].includes(btn) ? "bg-zinc-300 hover:bg-zinc-400 dark:bg-zinc-700/80 dark:hover:bg-zinc-600/80" : "bg-zinc-100 hover:bg-zinc-200 dark:bg-zinc-800 dark:hover:bg-zinc-700 dark:text-white")
              } font-bold text-xl rounded-lg h-16 flex justify-center items-center shadow-lg transition-transform transform active:scale-95 ${btn === "0" ? "col-span-2" : "col-span-1"
              }`}
          >
            {btn}
          </button>
        ))}
      </div>
    </div>
  );
};

export default Calculator;
